"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Item = require("./Item.styles");
var _Item2 = require("./Item.labels");
var _hooks = require("../../../hooks");
var _A = require("../../../UI/A");
var _Preloader = require("../../../UI/Preloader");
var _Img = require("../../../UI/Img");
var _ItemTypes = require("./partials/ItemTypes");
var _NewTag = require("./partials/ItemTag/partials/tags/NewTag");
var _bad_image = _interopRequireDefault(require("./resources/bad_image.png"));
var _itemLoader = _interopRequireDefault(require("./resources/item-loader.json"));
var _AttachedTag = require("./partials/ItemTag/partials/tags/AttachedTag");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Item = function Item(props) {
  var _props$view = props.view,
    view = _props$view === void 0 ? 'default' : _props$view,
    _props$isNew = props.isNew,
    isNew = _props$isNew === void 0 ? false : _props$isNew,
    _props$isAttached = props.isAttached,
    isAttached = _props$isAttached === void 0 ? false : _props$isAttached,
    _props$url = props.url,
    url = _props$url === void 0 ? '' : _props$url,
    banner = props.banner,
    onItemClick = props.onItemClick,
    label = props.label,
    optionalData = props.optionalData,
    isMobileSupported = props.isMobileSupported,
    itemTypes = props.itemTypes,
    itemBannerChildren = props.itemBannerChildren,
    title = props.title,
    subTitle = props.subTitle,
    duration = props.duration,
    type = props.type,
    itemInfoChildren = props.itemInfoChildren,
    itemExtraInfoChildren = props.itemExtraInfoChildren;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var getLabel = (0, _hooks.useLabels)({
    labels: _Item2.labels
  });
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isReady = _useState2[0],
    setIsReady = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isItemOver = _useState4[0],
    setIsItemOver = _useState4[1];
  var styles = (0, _Item.useStyles)(props, isReady, isItemOver);
  var bannerWidth = view === 'horizontal' ? type === 'book' ? '100%' : 100 : 220;
  var bannerHeight = view === 'horizontal' ? type === 'book' ? 'auto' : 85 : 186;
  var handleItemIsReady = function handleItemIsReady() {
    setIsReady(true);
  };
  var handleMouseEnter = function handleMouseEnter() {
    setIsItemOver(true);
  };
  var handleMouseLeave = function handleMouseLeave() {
    setIsItemOver(false);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("article", {
    className: styles['cc-Item'],
    children: [!isReady && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-Item__preloader'],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Preloader.Preloader, {
        url: _itemLoader.default
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-Item__tags'],
      children: [isNew && /*#__PURE__*/(0, _jsxRuntime.jsx)(_NewTag.NewTag, {
        label: getLabel('new'),
        isWithSpout: view === 'horizontal' ? false : true,
        view: view
      }), isAttached && /*#__PURE__*/(0, _jsxRuntime.jsx)(_AttachedTag.AttachedTag, {
        label: getLabel('attached'),
        isWithSpout: view === 'horizontal' ? false : true,
        view: view
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-Item__container'],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
        isBtnView: true,
        view: "text",
        customStyle: {
          width: '100%'
        },
        to: url,
        target: "_blank",
        onClick: onItemClick,
        category: "tile",
        label: label,
        optionalData: optionalData,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: styles['cc-Item__main-content'],
          onMouseEnter: handleMouseEnter,
          onMouseLeave: handleMouseLeave,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: styles['cc-Item__banner'],
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Img.Img, {
              onLoad: handleItemIsReady,
              src: banner,
              fallback: _bad_image.default,
              alt: title,
              width: bannerWidth,
              height: bannerHeight,
              borderRadius: {
                borderRadius: 10
              }
            }), view === 'default' && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: styles['cc-Item__banner-content'],
              children: [!isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ItemTypes.ItemTypes, {
                itemTypes: itemTypes,
                isMobileSupported: isMobileSupported,
                view: view
              }), itemBannerChildren]
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: styles['cc-Item__content'],
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: styles['cc-Item__title'],
              children: title
            }), view === 'horizontal' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ItemTypes.ItemTypes, {
              itemTypes: itemTypes,
              isMobileSupported: isMobileSupported,
              view: view
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: styles['cc-Item__info'],
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: styles['cc-Item__sub-title'],
                children: subTitle
              }), Number(duration) > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: styles['cc-Item__duration'],
                children: type === 'course' ? duration === 999 ? "".concat(getLabel('yearly')) : "".concat(duration, " ").concat(getLabel('hours')) : "".concat(Number(duration) > 120 ? '120+' : duration, " ").concat(getLabel('minutes'))
              })]
            }), itemInfoChildren]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: styles['cc-Item__extra-content'],
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: styles['cc-Item__extra-info'],
              children: itemExtraInfoChildren
            })
          })]
        })
      })
    })]
  });
};
exports.Item = Item;